/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const deps = ['Api'];
const factory = function (Api) {
  class ReportsApi extends Api {
    constructor() {
      super('reports');
    }
  }

  return new ReportsApi();
};

factory.$inject = deps;
module.exports = factory;
